// To add a new blog post:
//   1. Drop a markdown file in `public/blogs/<slug>.md` (images go in `public/blogs/images/`).
//   2. Add an entry to `blogs` below referencing that slug.
//
// Markdown supports: GitHub-flavored markdown, LaTeX via $...$ and $$...$$, images, code blocks.

export type BlogType = {
  slug: string;
  title: string;
  description: string;
  date: string;            // ISO YYYY-MM-DD
  cover?: string;          // optional path under /blogs/images/...
  readTime?: string;       // e.g. "7 min read"
};

export type ArticleType = {
  title: string;
  description: string;
  url: string;
  source?: string;         // publication / author
  date?: string;           // ISO YYYY-MM-DD
};

export const blogs: BlogType[] = [
  {
    slug: 'apiary',
    title: 'Apiary: A Hive of Agents for Autonomous ML Research',
    description: 'I built a multi-agent orchestration framework for autonomous ML experiments. N agents, parallel worktrees, and a file-based distributed registry inspired by how bees share a hive.',
    date: '2026-04-22',
    readTime: '7 min read',
  },
];

export const articles: ArticleType[] = [
  {
    title: 'Attention Is All You Need',
    description: 'The original Transformer paper — still the best starting point for understanding modern LLM architectures.',
    url: 'https://arxiv.org/abs/1706.03762',
    source: 'Vaswani et al., 2017',
    date: '2017-06-12',
  },
];
